import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  gridItem: {
    marginTop: '1rem',
    position: 'relative',
    padding: 0,
  },
  divider: {
    marginTop: '1rem',
  },
  activityTitle: {
    display: 'flex',
    flexFlow: 'wrap',
  },
  activity: {
    display: 'inline-block',
  },
}));
